import { ALOHA_SCROLL_CONTAINER_ID, SIMPLE_SCROLL_CONTAINER_ID } from '@apps/guest/routes/GuestSite/GuestSite.constants';
import { withWindow } from '@shared/utils/withWindow';
import { throttle } from 'lodash-es';
import { useEffect, useState } from 'react';

const SCROLL_THRESHOLD = 100;

export const useMenuButtonScroll = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    return withWindow(global => {
      const target = global.document.getElementById(SIMPLE_SCROLL_CONTAINER_ID) || global.document.getElementById(ALOHA_SCROLL_CONTAINER_ID) || global;

      const handleScroll = throttle(() => {
        const scrollY = 'scrollY' in target ? target.scrollY : target.scrollTop;

        setHasScrolled(scrollY > SCROLL_THRESHOLD);
      }, 100);

      handleScroll();

      target.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        handleScroll.cancel();
        target.removeEventListener('scroll', handleScroll);
      };
    });
  }, []);

  return { hasScrolled };
};
